import instance from "services/axiosServices";
import { useQuery } from "@tanstack/react-query";

/**
 * Função para buscar os produtos da API de empreendimento baseados na revenda.
 *
 * @param {boolean} enabled - Indica se a query deve ser executada.
 * @returns {UseQueryResult<any, unknown>} - Resultado da query.
 *
 */
export function fetchProdutosRevenda(enabled?: boolean): any {
  const fetch = async (): Promise<any> => {
    const url = "locais/app-web/produtos/listar-produto-revenda/v1";
    const response = await instance.get(url);
    return response?.data?.data;
  };

  const query = useQuery({
    queryFn: async () => fetch(),
    queryKey: ["fetch-produtos-revenda"],
    enabled: enabled ?? true,
    refetchOnWindowFocus: false,
  });

  return query;
}
